import _ from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AsyncLoadStatus, DatasetDataViewProps } from '../../common/types';
import DatasetTable from '../../components/DatasetTable';

import {
  actualityKpiMetricsTableData,
  actualityKpiMetricsTableDataLoadStatus,
  actualityKpiMetricsTableDataState,
  actualityKpiMetricsTableTotalCount,
} from '../store/actuality.kpiMetrics.state';
import { KpiGroupRow } from '../store/actuality.types';
import useActualityKpiMetricsTableConfig from './useActualityKpiMetricsTableConfig';
import useLoadActualityKpiMetricsTableData from './useLoadActualityKpiMetrics';

const ActualityKpiMetricsTable: React.FC<
  DatasetDataViewProps<KpiGroupRow>
> = props => {
  const { t } = useTranslation('dataset');
  const data = useRecoilValue(actualityKpiMetricsTableData);
  const totalCount = useRecoilValue(actualityKpiMetricsTableTotalCount);
  const status = useRecoilValue(actualityKpiMetricsTableDataLoadStatus);
  const [dataState, setDataState] = useRecoilState(
    actualityKpiMetricsTableDataState,
  );

  const [loadCallback, reset] = useLoadActualityKpiMetricsTableData();
  const columnsConfig = useActualityKpiMetricsTableConfig();

  const searchValues =
    (dataState as { searchValues: Record<string, string> })?.searchValues || {};

  useEffect(() => {
    callDataLoad(searchValues);
  }, [props.id, searchValues]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  function callDataLoad(searchValues: Record<string, string>) {
    loadCallback({
      searchValues,
    });
  }

  // async function startExportCSV() {
  //   return await exportCSV({
  //     converterConfig: {
  //       columnsConfig,
  //     },
  //   });
  // }

  // async function onStartExportCurrentViewCSV() {
  //   return await exportCSV({
  //     searchValues,
  //     converterConfig: {
  //       columnsConfig,
  //     },
  //   });
  // }

  const isLoading = status === AsyncLoadStatus.Loading;
  const itemsCount = Array.isArray(data) ? data.length : 0;
  const hasSearchFilter = Object.keys(searchValues).length > 0;

  if (props.customRenders) {
    _.forEach(props.customRenders, (renderer, key) => {
      const cfg = _.find(columnsConfig, c => c.field === key);
      if (!_.isNil(cfg)) {
        cfg.render = renderer;
      }
    });
  }

  return (
    <DatasetTable
      onLoadNext={function (): void {
        throw new Error('Function not implemented.');
      }}
      id={props.id}
      data={Array.isArray(data) ? data : []}
      columnsConfig={columnsConfig}
      keyFields={['groupId']}
      hasCounter
      hideScreenTitle={props.hideScreenTitle}
      subtitle={t`KPI Metrics by Groups`}
      title={props.title || t`KPI Metrics Table`}
      isSticky
      totalCount={totalCount as number}
      searchValues={searchValues as any}
      isLoading={isLoading}
      onSearch={v => {
        setDataState({ ...(dataState as any), searchValues: v });
      }}
      // onStartExportClick={startExportCSV}
      //   {...(hasSearchFilter
      //     ? { onStartExportCurrentViewClick: onStartExportCurrentViewCSV }
      //   : null)}
      hasRowCounter // disablePagination
    />
  );
};

export default ActualityKpiMetricsTable;
